<template>
  <div>
    <Modal
      ref="modal"
      title="Decline candidate"
      body="Are you sure you want to mark this candidate as Declined?"
      action="Declined"
      actionColor="red"
      @closeModal="handleCancel"
      @handleAction="handleDeclined"
    >
    </Modal>
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';

export default {
  components: {
    Modal,
  },
  methods: {
    handleDeclined() {
      const self = this;
      fetch(`/api/contacts/${self.$route.params.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
        body: JSON.stringify({
          stage: 'Declined',
        }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.status != 'error') {
            self.$emit('handleContactDeclined');
            self.$refs.modal.success();
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Candidate declined',
              alertDescription:
                'Your candidate has been successfully marked as declined.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$refs.modal.error();
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Candidate disqualification error',
              alertDescription: data.message,
            });
          }
        });
    },
    handleCancel() {
      this.$emit('handleContactDeclinedCancel');
    },
  },
};
</script>
